<template>
  <div>
    <div class="row">
      <div class="flex md12">
        <va-card>
          <div class="row">
            <div class="flex md12">
              <h3 :style="{ color: this.$themes.primary  }">MAPA</h3>
            </div>
            <div class="flex md6">
              <div class="row">
                <div class="flex md1">
                  <va-button
                    color="info"
                    @click="startDeclare"
                    icon="fa fa-plus"
                    :disabled="isDuplicate"
                  />
                </div>
                <div class="flex md11">
                  <h4
                    class="fullwidth"
                    style="position: relative;
          top: 0.5em;"
                  >Déclarer le mois</h4>
                </div>
              </div>
            </div>
          </div>
          <va-data-table
            class="va-table--hoverable va-table--stripped"
            :fields="fields"
            :data="listDeclaration"
            :per-page="10"
          >
            <template slot="actions" slot-scope="props">
              <va-button
                class="fullwidth"
                color="info"
                outline
                @click="redeclareMapa(props.rowData)"
              >Renvoyer le courriel</va-button>
              <va-button
                class="fullwidth"
                color="info"
                outline
                @click="getFile(props.rowData.idexcel, props.rowData.date_declaration)"
              >Télécharger la déclaration</va-button>
            </template>
          </va-data-table>
        </va-card>
      </div>
    </div>
    <va-modal
      class="modal"
      large
      title="Déclaration Mapa"
      v-model="showDeclareMapa"
      cancelClass="none"
      okText="Déclarer"
      cancelText="Annuler"
      max-width="100%"
      v-on:ok="declareMapa"
      v-on:cancel="closeDeclareMapa"
      noEscDismiss
      noOutsideDismiss
      :hideDefaultActions="deactiveSendingButton"
    >
      <div class="row fixed-width">
        <div
          class="flex md12 mb-3"
        >Déclaration de {{infosDeclaration.totalNumberMapa}} adhérents dont {{infosDeclaration.lastMonthNumber}} en {{getMonth()}}.</div>
        <div class="flex md12 mb-3">
          <va-button outline color="info" @click="getTmpFile">Télécharger le fichier généré</va-button>
        </div>
        <div class="flex md12">
          <div class="row row-inside">
            <va-checkbox v-model="sendMail" />
            <span class="checkbox-label">Déclaration automatique (envoi du courriel)</span>
          </div>
        </div>
      </div>
    </va-modal>
    <va-modal
      class="modal"
      large
      title="Renvoi déclaration Mapa"
      v-model="showSendAgainMapa"
      okText="Renvoyer la déclaration"
      cancelText="Annuler"
      max-width="100%"
      v-on:ok="sendAgainMapa"
      v-on:cancel="closeDeclareMapa"
      noEscDismiss
      noOutsideDismiss
      :hideDefaultActions="deactiveSendingButton"
    >Confirmer le renvoi du courriel de déclaration</va-modal>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  name: "exportMapa",
  data() {
    return {
      showSendAgainMapa: false,
      showDeclareMapa: false,
      sendMail: true,
      infosDeclaration: {
        totalNumberMapa: null,
        lastMonthNumber: null,
        xlsxFile: null
      },
      listDeclaration: [],
      isDuplicate: true,
      activeDeclaration: null,
      deactiveSendingButton: false
    };
  },
  created() {
    this.getListDeclarations();
  },
  methods: {
    redeclareMapa(rowData) {
      this.showSendAgainMapa = true;
      this.activeDeclaration = rowData;
    },
    async sendAgainMapa() {
      this.showSendAgainMapa = true;
      if (this.activeDeclaration) {
        try {
          this.deactiveSendingButton = true;
          await axios.get("/api/mapa/redeclare", {
            params: {
              infosDeclaration: this.activeDeclaration
            }
          });
          this.launchEpicmaxToast("Déclaration renvoyée");
          this.getListDeclarations();
          this.showSendAgainMapa = false;
          this.deactiveSendingButton = false;
        } catch (err) {
          this.launchEpicmaxToast("Erreur lors du renvoi de la déclaration");
          this.showSendAgainMapa = false;
          this.deactiveSendingButton = false;
        }
      } else {
        this.launchEpicmaxToast("Erreur, aucune déclaration séléctionnée");
        this.showSendAgainMapa = false;
        this.deactiveSendingButton = false;
      }
    },
    closeDeclareMapa() {
      if (this.activeDeclaration) {
        this.activeDeclaration = null;
      }
      if (this.infosDeclaration.xlsxFile) {
        //clean temporary file
        this.infosDeclaration = {
          totalNumberMapa: null,
          lastMonthNumber: null,
          xlsxFile: null
        };
      }
    },
    async declareMapa() {
      try {
        this.showDeclareMapa = true;
        this.deactiveSendingButton = true;
        let res = await axios.get("/api/mapa/declare-month", {
          params: {
            idTmpFile: this.infosDeclaration.xlsxFile,
            totalNumberMapa: this.infosDeclaration.totalNumberMapa,
            lastMonthNumber: this.infosDeclaration.lastMonthNumber,
            sendEmail: this.sendMail
          }
        });
        this.launchEpicmaxToast("Déclaration effectuée");
        this.showDeclareMapa = false;
        this.deactiveSendingButton = false;
        this.getListDeclarations();
      } catch (err) {
        console.log(err);
        this.deactiveSendingButton = false;
        this.launchEpicmaxToast("Erreur lors de la déclaration");
      }
    },
    getMonth() {
      moment.locale("fr");
      console.log(moment().format("MMMM"));
      return moment().format("MMMM");
    },
    async startDeclare() {
      try {
        console.log("start declaration");
        let excel = await axios.get("/api/mapa/generate-excel");
        console.log(excel.data);
        this.infosDeclaration = excel.data;
        this.showDeclareMapa = true;
      } catch (err) {
        console.log(err);
        this.launchEpicmaxToast(
          "Erreur lors de la génération du fichier de déclaration. Aucune déclaration n’a été envoyée."
        );
        // quote mark 0146
      }
    },
    async getTmpFile() {
      try {
        let res = await axios.get("/api/mapa/get-tmp-excel", {
          params: {
            idTmpFile: this.infosDeclaration.xlsxFile
          }
        });
        let fileUri = res.data;
        moment.locale("fr");
        this.downloadItem(
          fileUri,
          "Déclaration temporaire " +
            moment().format("MMMM") +
            " " +
            moment().format("YYYY")
        );
      } catch (err) {
        console.log(err);
        this.showDeclareMapa = false;
        this.launchEpicmaxToast(
          "Le fichier n'a pas pu être récupéré, veuillez rééssayer."
        );
        // quote mark 0146
      }
    },
    async getFile(fileId, date) {
      try {
        let res = await axios.get("/api/mapa/get-excel", {
          params: {
            idFile: fileId
          }
        });
        let fileUri = res.data;
        moment.locale("fr");
        this.downloadItem(
          fileUri,
          "Déclaration " +
            moment(date).format("MMMM") +
            " " +
            moment(date).format("YYYY")
        );
      } catch (err) {
        console.log(err);
        this.launchEpicmaxToast(
          "Le fichier n'a pas pu être récupéré, veuillez rééssayer."
        );
      }
    },
    async getListDeclarations() {
      try {
        let res = await axios.get("/api/mapa/list-declarations");
        res.data.listDeclaration.forEach(element => {
          element.date_normed = moment(element.date_declaration).format(
            "DD/MM/YYYY"
          );
          element.type = !element.idoriginal
            ? "Déclaration MAPA"
            : "Renvoi MAPA";
          element.statistiques =
            element.nbadherents +
            " déclaré en cours / " +
            element.nbmonth +
            " en " +
            moment().format("MMMM");
        });

        this.listDeclaration = res.data.listDeclaration;
        this.isDuplicate = res.data.isDuplicate;
        console.log(this.listDeclaration);
        console.log("duplicate", this.isDuplicate);
      } catch (err) {
        console.log(err);
        this.launchEpicmaxToast("Erreur lors du chargement du module.");
        // quote mark 0146
      }
    },
    downloadItem(url, name) {
      axios
        .get(url, { responseType: "blob" })
        .then(response => {
          const blob = new Blob([response.data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = name;
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch(console.error);
    },
    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000
      });
    }
  },
  computed: {
    fields() {
      return [
        {
          name: "date_normed",
          title: "Déclaration",
          sortField: "date_normed",
          width: "20%"
        },

        {
          name: "type",
          title: "Type",
          sortField: "type",
          width: "20%"
        },
        {
          name: "statistiques",
          title: "Statistiques",
          width: "20%"
        },
        {
          name: "uname",
          title: "Déclarant",
          sortField: "affectation_username",
          width: "20%"
        },
        {
          name: "__slot:actions",
          width: "20%"
        }
      ];
    }
  }
};
</script>

<style>
.fullwidth {
  width: 90%;
}
.fixed-width {
  width: 35vw;
}
</style>
